<template>
	<el-dialog :title="title" :close-on-click-modal='false' :visible="dialogFormVisible" @close='close'>
		<slot></slot>
		<div slot="footer" class="dialog-footer" style="display:flex;">
			<slot name="footer"></slot>
            <div style="flex:1;">
                <el-button @click="close">Close</el-button>
            </div>
            <div style="flex:1;">
            <el-button type="primary" @click="submit">Submit</el-button>
            </div>
		</div>
	</el-dialog>
</template>

<script>
export default {
    props:{
        title:{
            required:true
        }
    },
    data () {
        return {
            dialogFormVisible:true
        };
    },
    methods:{
        close () {
            this.$emit("close");
        },
        submit () {
            this.$emit("submit");
        }
    }
};
</script>

<style>
</style>